type MemberNameFields = {
  preferredName?: string | null;
  firstName?: string | null;
};

/**
 * Name shown in greetings and member-facing copy. Prefers a non-empty
 * preferred name; otherwise falls back to first name.
 */
export function getMemberDisplayName(
  member: MemberNameFields = {}
): string {
  const preferredName = member.preferredName?.trim();
  if (preferredName) {
    return preferredName;
  }

  return member.firstName?.trim() ?? "";
}

/**
 * Optional in-form override (e.g. onboarding profile step) takes precedence.
 */
export function resolveMemberDisplayName(
  member: MemberNameFields = {},
  overrideName?: string | null
): string {
  const override = overrideName?.trim();
  if (override) {
    return override;
  }

  return getMemberDisplayName(member);
}
